import React from "react";
import "../styles/linkTree.css"; // Add your styles here or use inline styles
import EnableScrollOnPage from "../Integrations/EnableScroll";
import { FaInstagram, FaYoutube } from "react-icons/fa";

const LinkTree = () => {
  return (
    <div className="linktree-container">
      <EnableScrollOnPage />
      <div className="linktree-logo">
        <img src="/logo.png" alt="TrainChess Logo" />
      </div>
      <h1 className="linktree-title">Train Chess</h1>
      <p className="linktree-bio">
        Welcome to Train Chess. Let's get started.
      </p>

      <div className="linktree-links">
        <a href="https://apps.apple.com/us/app/the-exchange-chess/id6742661001" target="_blank" rel="noopener noreferrer">
          The Exchange for iOS
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.theexchange" target="_blank" rel="noopener noreferrer">
          The Exchange for Android 
        </a>
        <a href="https://www.chess.com/club/train-chess-1" target="_blank" rel="noopener noreferrer">
          Join Our Chess.com Club
        </a>
        <a href="https://trainchess.net" target="_blank" rel="noopener noreferrer">
          Visit TrainChess.net
        </a>
        <div className="linktree-socials">
          <a href="https://www.instagram.com/train.chess" target="_blank" rel="noopener noreferrer" className="social-button">
            <FaInstagram size={36} />
          </a>
          <a href="https://www.youtube.com/channel/UCO7Guyli8rWF3CqVOIM1nZA" target="_blank" rel="noopener noreferrer" className="social-button">
            <FaYoutube size={36} />
          </a>
        </div>

      </div>
    </div>
  );
};

export default LinkTree;